import { useRef, useState } from 'react'

import type { InputAudioHandle } from '@/ui/components/InputAudio/InputAudio'

// State of an InputAudio that is driven from outside: the parent renders the microphone button and the recording row
// itself is rendered by InputAudio (spread `audioInputProps` on it)
const useAudioRecording = () => {
    const inputAudioRef = useRef<InputAudioHandle | null>(null)
    const [isRecording, setIsRecording] = useState<boolean>(false)
    const [isTranscribing, setIsTranscribing] = useState<boolean>(false)

    const toggleRecording = async (): Promise<void> => {
        const inputAudio = inputAudioRef.current
        if (!inputAudio) return

        if (isRecording) {
            inputAudio.stopRecording()
        } else {
            await inputAudio.initMedia()
        }
    }

    const audioInputProps = {
        ref: inputAudioRef,
        onRecordingChange: setIsRecording,
        onTranscribingChange: setIsTranscribing,
    }

    return { audioInputProps, isRecording, isTranscribing, toggleRecording }
}

export default useAudioRecording
